import React from 'react';
import OldBillDetails from './lis-old-bill-details';
import NewBillDetails from './lis-new-bill-details';

class PublicBillDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ marginTop: "-15px" }}>
                {this.props.match.params.sessionCode > 20251 || (this.props.match.params.sessionCode == 20251 && this.props.match.params.billnumber === "HB1600" && window.location.href.includes("qa"))
                    ? <NewBillDetails key={this.props?.match?.params?.billnumber}
                        params={this.props.match.params}
                        location={this.props.location}
                        history={this.props.history}
                    />
                    : <OldBillDetails
                        params={this.props.match.params}
                        location={this.props.location}
                        history={this.props.history}
                    />
                }
            </div>
        )
    }
}

export default PublicBillDetails;
